import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Link as LinkIcon } from 'lucide-react';
import { Link } from 'react-router';

const ServiceRelated = ({ services = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(null);
  
  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === services.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    
    return () => clearInterval(interval);
  }, [services.length]);
  
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === services.length - 1 ? 0 : prevIndex + 1
    );
  };
  
  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? services.length - 1 : prevIndex - 1
    );
  };
  
  const selectSlide = (index) => {
    setCurrentIndex(index);
  };
  
  if (!services.length) return null;
  
  return (
    <section className="py-16 bg-gradient-to-r from-teal-50 to-green-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-700">
          <span className="relative inline-block pb-2">
            Related Services
            <span className="absolute bottom-0 left-0 w-full h-1 bg-lime-500 transform origin-left transition-all duration-300"></span>
          </span>
        </h2>
        
        <div className="relative max-w-4xl mx-auto overflow-hidden">
          {/* Navigation buttons */}
          <button 
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white text-teal-600 p-2 rounded-full shadow-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-teal-400 transform hover:scale-110"
            aria-label="Previous service"
          >
            <ChevronLeft size={24} />
          </button>
          
          <button 
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white text-teal-600 p-2 rounded-full shadow-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-teal-400 transform hover:scale-110"
            aria-label="Next service"
          >
            <ChevronRight size={24} />
          </button>
          
          {/* Cards container */}
          <div className="flex justify-center">
            <div 
              className="w-full md:w-4/5 p-6 rounded-xl bg-white shadow-xl transition-all duration-500 transform hover:shadow-2xl"
              style={{ 
                transform: `translateY(${isHovering === currentIndex ? '-8px' : '0'})`,
                transition: 'transform 0.3s ease-in-out'
              }}
              onMouseEnter={() => setIsHovering(currentIndex)}
              onMouseLeave={() => setIsHovering(null)}
            >
              <div className="flex flex-col items-center">
                <div className="text-teal-600 text-xl mb-4">
                  {services[currentIndex].detail}
                </div>
                <Link
                    to={services[currentIndex].link}  
                  className="mt-6 inline-flex items-center px-4 py-2 bg-teal-500 text-white rounded-lg hover:bg-lime-500 transition-colors duration-300 group"
                >
                  Learn More
                  <LinkIcon className="ml-2 transform group-hover:translate-x-1 transition-transform duration-300" size={16} />
                </Link>
              </div>
            </div>
          </div>
          
          {/* Dots navigation */}
          <div className="flex justify-center mt-8">
            {services.map((_, index) => (
              <button
                key={index}
                onClick={() => selectSlide(index)}
                className={`h-3 mx-1 rounded-full transition-all duration-300 focus:outline-none
                  ${index === currentIndex ? 'bg-teal-600 w-6' : 'bg-lime-300 hover:bg-lime-400 w-3'}`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceRelated;